export const isEmail = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(v || "").trim());

export const isFrenchPhone = (v) => {
  const n = String(v || "").replace(/[\s.\-]/g, "");
  return /^(?:\+33|0)[1-9]\d{8}$/.test(n);
};

// Ville / code postal : au moins 2 caractères ; si des chiffres sont présents,
// ils doivent former un code postal français à 5 chiffres.
export const isCityPostal = (v) => {
  const s = String(v || "").trim();
  if (s.length < 2) return false;
  const digits = s.replace(/\D/g, "");
  if (digits.length > 0 && digits.length !== 5) return false;
  return true;
};

export const isPostal5 = (v) => /^\d{5}$/.test(String(v || "").trim());
